"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpiderChart = exports.getLabelTextGroup = void 0;
const react_1 = __importStar(require("react"));
const group_1 = require("@visx/group");
const curve_1 = require("@visx/curve");
const text_1 = require("@visx/text");
const shape_1 = require("@visx/shape");
const scale_1 = require("@visx/scale");
const point_1 = require("@visx/point");
const grid_1 = require("@visx/grid");
const polished_1 = require("polished");
const variants_1 = require("../../themes/variants");
const styled_components_1 = require("styled-components");
const main_1 = require("../useTooltip/main");
const list_1 = require("../useTooltip/list");
function genCoords(angle, radius) {
    const x = radius * Math.sin(angle);
    const y = radius * Math.cos(angle);
    return { x, y };
}
function genPoints(keys, radius) {
    const step = (Math.PI * 2) / keys.length;
    return keys.map((label, i) => {
        const angle = i * step;
        const { x, y } = genCoords(angle, radius);
        const rad = Math.atan2(y, x);
        const deg = rad * (180 / Math.PI);
        return {
            x,
            y,
            label,
            angle,
            rad,
            deg,
        };
    });
}
function genPolygonPoints(dataArray, scale, getValue) {
    const step = (Math.PI * 2) / dataArray.length;
    const points = dataArray.map(({ label }, i) => {
        const xVal = scale(getValue(dataArray[i])) * Math.sin(i * step);
        const yVal = scale(getValue(dataArray[i])) * Math.cos(i * step);
        return {
            x: xVal,
            y: yVal,
            label,
        };
    });
    return { points };
}
function getLabelTextGroup({ point, fillColor, fontSize, radius, maxLength = 20, }) {
    const rows = point.label.split("").reduce((prev, curr) => {
        const str = prev[prev.length - 1];
        if (curr === " ")
            prev.push("");
        else if (str === "" || (str === null || str === void 0 ? void 0 : str.length) % maxLength)
            prev[prev.length - 1] += curr;
        else
            prev.push(curr);
        return prev;
    }, []);
    const texts = point.y > 0 ? rows : rows.reverse();
    return (react_1.default.createElement(group_1.Group, null, texts.map((txt, i) => {
        const coord = genCoords(point.angle, radius + 15 * (i + 1));
        return (react_1.default.createElement(text_1.Text, Object.assign({ key: `text-${point.label}-${i}` }, coord, { fill: fillColor, style: { fontWeight: "bold" }, fontSize: fontSize, angle: point.y < 0 ? point.deg + 90 : point.deg - 90, textAnchor: "middle", verticalAnchor: point.y < 0 ? "end" : "start" }), txt.toUpperCase()));
    })));
}
exports.getLabelTextGroup = getLabelTextGroup;
function SpiderChart({ width, height, variant, data, colors, selectedLabel, onChange, maxLength, tooltip = true, tooltipAxis = true, margin = { top: 30, right: 30, bottom: 30, left: 30 }, }) {
    const theme = (0, styled_components_1.useTheme)();
    const chartTooltip = (0, main_1.useTooltip)();
    const svgRef = (0, react_1.createRef)();
    const defaultColor = (0, polished_1.lighten)(0.2, (0, variants_1.variantTextColor)({ theme }));
    const primaryColor = (0, variants_1.variantTextColor)({ theme, variant });
    const bgColor = (0, variants_1.variantBgColor)({ theme, variant });
    const xMax = width - margin.left - margin.right;
    const yMax = height - margin.top - margin.bottom;
    const radius = Math.min(xMax, yMax) / 2;
    const keys = data &&
        data.length &&
        Object.keys(data[0].values).filter((i) => i !== "xLabel");
    // Order element by total points descending
    data = data.sort((a, b) => {
        const avg = keys &&
            keys.reduce((prev, curr) => {
                prev.a += a.values[curr];
                prev.b += b.values[curr];
                return prev;
            }, { a: 0, b: 0 });
        if (!avg)
            return 0;
        return avg.a > avg.b ? -1 : 1;
    });
    const yScale = (0, scale_1.scaleLinear)({
        domain: [0, 1],
        range: [0, radius],
    });
    if (!keys || width < 10)
        return null;
    colors =
        colors ||
            (() => {
                const maxDiff = 0.3;
                const step = maxDiff / data.length;
                const colors = [];
                const start = (0, polished_1.lighten)(maxDiff / 2, primaryColor);
                let dark = 0;
                while (colors.length < data.length) {
                    colors.push((0, polished_1.darken)(dark, start));
                    dark = dark + step;
                }
                return colors;
            })();
    function getTooltipData(data, renderer) {
        return {
            title: (react_1.default.createElement("span", { style: { color: colorScale(data.serie) } }, data.serie)),
            values: keys
                ? keys.map((key) => {
                    return {
                        label: key,
                        value: data.values[key],
                    };
                })
                : undefined,
            renderer,
        };
    }
    const colorScale = (0, scale_1.scaleOrdinal)({
        domain: data.map((item) => item.serie),
        range: colors,
    });
    const points = genPoints(keys, radius);
    const zeroPoint = new point_1.Point({ x: 0, y: 0 });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", { width: width, height: height, ref: svgRef },
            react_1.default.createElement("rect", { width: width, height: height, fill: bgColor, rx: 14 }),
            react_1.default.createElement(group_1.Group, { top: margin.top + yMax / 2, left: margin.left + xMax / 2 },
                react_1.default.createElement(grid_1.GridRadial, { scale: yScale, numTicks: 5, stroke: defaultColor, strokeWidth: 1 }),
                points.map((point) => {
                    const elm = getLabelTextGroup({
                        point,
                        radius,
                        fillColor: primaryColor,
                        fontSize: theme.fontSize,
                        maxLength: maxLength,
                    });
                    return (react_1.default.createElement(group_1.Group, null,
                        react_1.default.createElement(shape_1.Line, { key: `line-${point.label}`, from: zeroPoint, to: point, stroke: defaultColor }),
                        elm));
                }),
                data
                    .map((item) => {
                    const polygonPoints = genPolygonPoints(keys.map((key) => {
                        return {
                            label: key,
                            value: item.values[key],
                        };
                    }), (d) => { var _a; return (_a = yScale(d)) !== null && _a !== void 0 ? _a : 0; }, (d) => d.value);
                    const stroke = colorScale(item.serie);
                    const fill = (0, polished_1.rgba)(stroke, selectedLabel === item.serie ? 0.85 : 0.4);
                    console.log(polygonPoints.points);
                    return [
                        react_1.default.createElement(shape_1.LinePath, { curve: curve_1.curveCatmullRomClosed, key: item.serie, data: polygonPoints.points, x: (d) => d.x, y: (d) => d.y, shapeRendering: "geometricPrecision", strokeLinecap: "round", fill: fill, fillOpacity: 0.3, stroke: stroke, strokeWidth: 2, onMouseLeave: function handleMouseLeave() {
                                chartTooltip.hide();
                                onChange && onChange();
                            }, onMouseMove: function handleMouseMove(e) {
                                tooltip &&
                                    chartTooltip.positionSVGTooltip(e, svgRef.current, getTooltipData(item, tooltip));
                                onChange && selectedLabel !== item.serie && onChange(item);
                            } }),
                        ...polygonPoints.points.map((point, i) => {
                            return (react_1.default.createElement("circle", { key: `point-${item.serie}-${i}`, cx: point.x, cy: point.y, r: 4, fill: bgColor, stroke: stroke, strokeWidth: 2, onMouseLeave: function handleMouseLeave() {
                                    chartTooltip.hide();
                                    onChange && onChange();
                                }, onMouseMove: function handleMouseMove(e) {
                                    (tooltipAxis || tooltip) &&
                                        chartTooltip.positionSVGTooltip(e, svgRef.current, tooltipAxis
                                            ? {
                                                title: point.label,
                                                values: data.map((datum) => {
                                                    return {
                                                        label: datum.serie,
                                                        value: datum.values[point.label],
                                                        color: colorScale(datum.serie),
                                                    };
                                                }),
                                                renderer: typeof tooltipAxis === "function"
                                                    ? tooltipAxis
                                                    : list_1.ChartTooltipList,
                                            }
                                            : getTooltipData(item, tooltip));
                                    onChange && e.preventDefault();
                                    onChange && e.stopPropagation();
                                    onChange &&
                                        selectedLabel !== item.serie &&
                                        onChange(item);
                                } }));
                        }),
                    ];
                })
                    .reduce((prev, curr, i) => {
                    // Move all lines before and circles after
                    if (prev.length) {
                        prev.splice(i, 0, curr[0]);
                    }
                    else
                        prev.push(curr[0]);
                    prev = prev.concat(curr.slice(1));
                    return prev;
                }, []))),
        chartTooltip.element));
}
exports.SpiderChart = SpiderChart;
//# sourceMappingURL=main.js.map